import toTitleCase from "./TitleCase";

export const toHumanReadable = (data: any) => {
    return Object.entries(data)
        .map(([name, value]) => `${toTitleCase(name)}: ${value}`)
        .join('\n ');
};

export default toHumanReadable;
